//CLIENT MODULE
export const MARK_DELIVERY_AS_PAID = 'markDeliveryAsPaid'

export const CREATE_DEALER = 'createDealer'
export const UPDATE_DEALER = 'updateDealer'
export const DELETE_DEALER = 'deleteDealer'

export const GET_DEALERS = 'getDealers'
export const GET_DEALER_DELIVERIES = 'getDealerDeliveries'

export const GET_SHIPPINGS = 'getShippings'
export const GET_SHIPPING_RATES = 'getShippingRates'

export const CREATE_SHIPPING_RATE = 'createShippingRate'
export const UPDATE_SHIPPING_RATE = 'updateShippingRate'
export const DELETE_SHIPPING_RATE = 'deleteShippingRate'

export const GET_LINKED_COMPANIES = 'getLinkedCompanies'
export const LINK_DELIVERY_COMPANY = 'linkDeliveryCompany'
export const UNLINK_DELIVERY_COMPANY = 'unlinkDeliveryCompany'






